import { render, staticRenderFns } from "./diamondTakeRecord.vue?vue&type=template&id=2003f7d4&scoped=true"
import script from "./diamondTakeRecord.vue?vue&type=script&lang=ts"
export * from "./diamondTakeRecord.vue?vue&type=script&lang=ts"
import style0 from "./diamondTakeRecord.vue?vue&type=style&index=0&id=2003f7d4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2003f7d4",
  null
  
)

export default component.exports